import { Options } from "@components/modules/Table/types"
import useStatic from "@hooks/useStatic"

export default function useMemberSalonsTable() {
    return useStatic<Options<Club.Resources.MembershipSalon>>({
        heading: "Salons"
    })
}